import { Badge, Tooltip } from '@mantine/core';
import { IconPlugConnectedX } from '@tabler/icons-react';

export function UnsubscribedBadge() {
    return (
        <Tooltip label='Отписался'>
            <Badge color='red' size='xs' variant='filled' pt={4}>
                <IconPlugConnectedX size={14}/>
            </Badge>
        </Tooltip>
    );
}